/**
 * Used to create an AB Test using cookies
 * The ABTest class takes in an AB Test Name and a number of days for the test to run
 * Conditionally will add a class to the body tag for one subset of users (who meet the criteria, cookie value = true)
 **/

class ABTest { 
    constructor(testName, testLength){
      this.testName = testName;
      this.testLength = testLength;
    }

    setABCookie(testName, value, testLength){
      this.expiryDate = new Date(this.testStartDate.getTime() + (1000 * 60 * 60  * 24 * this.testLength))
      this.cookieValue = value + (( this.expiryDate == null) ? "" :"; expires=" + this.expiryDate.toUTCString()) + ';path=/'
      document.cookie = this.testName + "=" + this.cookieValue;
    }

    fetchCookie(){
      return document.cookie.match('(^|;)\\s*' + this.testName + '\\s*=\\s*([^;]+)')?.pop() || '';
    }

    assignABTest(){
      if (this.testStartSeconds % 2 == 0){
        this.setABCookie(this.testName, true, this.testLength)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "abTestTriggered",
          testID: this.testName,
          experienceTriggered: true
        });
      } else {
        this.setABCookie(this.testName, false, this.testLength)
      }
    }

    startABTest() {
      if(!this.fetchCookie(this.testName)){
        this.testStartDate = new Date();
        this.testStartSeconds = this.testStartDate.getSeconds();
        this.assignABTest(this.abTestDateSecond)
      } else {
        if(this.fetchCookie(this.testName) == "true"){
          document.querySelector('html').classList.add(this.testName)
        }
      }
  }

  }